import React, { useEffect, useState } from "react";


export default function HomeContainer() {

    const [loading, setLoading] = useState(true);


    useEffect(()=>{

        setTimeout(()=>{
            setLoading(false);
        }, 2000);

        setLoading(false);

    }, []);

    

  return (
    <>

        {loading ? (
            <div className="loaderContainer">
                <div className="loader"></div>
                <p className="loadingText">Loading...</p>
            </div>
        ):(
            <main className="home">


                <div className="circles">
                    <span className="circle1"></span>
                    <span className="circle2"></span>
                    <span className="circle3"></span>
                </div>
                

                <div className="homeContainer">

                    <div className="titleSlogan">
                        <div className="title">
                            <span className="text">BidBrick</span>
                        </div>

                        <div className="slogan">
                            <span className="sloganText">Bid, Win, Move In!</span>
                        </div>

                    </div>
                    

                    <div className="data">

                    

                    </div>
                
                    
                </div>
            </main>
        )}

    </>
  );
}